<!-- Icons Start -->
<div class="container">
    <div class="section-title-wrap section-header text-center">
        <h5 class="custom-primary">Quel est notre processus de livraison ?</h5>
        <h2 class="title">Nous livrons votre commande en 4 étapes</h2>
        <p class="subtitle">
            Pour vous offrir une expérience culinaire exceptionnelle, notre processus de préparation en 4 étapes démarre par la prise de commande soigneusement orchestrée, la préparation méticuleuse des plats, une livraison rapide et fiable, pour que vous puissiez enfin savourer chaque bouchée de votre repas en toute satisfaction.
        </p>
    </div>
    <div class="row infographics-2">
        <div class="col-lg-3 col-md-6 col-sm-6" *ngFor="let item of processpost">
            <div class="ct-infographic-item">
                <i class="{{item.icon}}"></i>
                <h4>{{item.title}}</h4>
                <p>{{item.text}}</p>
            </div>
        </div>
    </div>
    <div class="section-btn">
        <button type="button" class="btn-custom" (click)="openOrderChooser()">commander en ligne</button>
    </div>
</div>
<!-- Icons End -->